/* ActivityLog — paginated audit feed for admin actions, scan starts,
   DocMaya conversions, license mutations, and user invites. Reads from
   GET /api/manage/activity-log via the parent. Stays pure-presentational:
   parent passes { entries, loading, error, onRetry }. */
import React from "react";
import { P, FC } from "../../shared/constants";
import EmptyState from "../components/EmptyState";
import ErrorState from "../components/ErrorState";
import Skeleton from "../components/Skeleton";
import { Clipboard } from "../icons";
var E = React.createElement;

export default function ActivityLog(props){
  var loading = !!props.loading;
  var error   = props.error || null;
  var entries = props.entries || [];

  if(loading) return E(Skeleton,{rows:8,height:20,label:"Loading activity…"});
  if(error)   return E(ErrorState,{title:"Couldn't load activity log.",
    message:String(error), onRetry:props.onRetry});

  if(entries.length===0){
    return E(EmptyState, {
      icon: E(Clipboard,{size:32}),
      title: "Activity log is empty.",
      message: "License changes, user invites, scan starts, and DocMaya conversions will appear here as they happen. Use the Refresh button on any admin tab to pull the latest activity."
    });
  }

  return E("div",null,
    E("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:12}},
      E("thead",null,
        E("tr",null,
          ["When","Actor","Action","Target","Product"].map(function(h){
            return E("th",{key:h,scope:"col",
              style:{padding:"10px 12px",textAlign:"left",
                background:P.bgS,borderBottom:"1px solid "+P.bdr,
                fontWeight:700,color:P.slateM,fontSize:11}},h);
          }))),
      E("tbody",null,
        entries.map(function(a,i){
          return E("tr",{key:a.id||i,style:{background:i%2===0?P.card:"#FAFBFE"}},
            E("td",{style:{padding:"10px 12px",borderBottom:"1px solid "+P.bdr,
              color:P.slateM,fontFamily:FC,fontSize:11,whiteSpace:"nowrap"}},
              a.createdAt?a.createdAt.replace("T"," ").slice(0,16):"—"),
            E("td",{style:{padding:"10px 12px",borderBottom:"1px solid "+P.bdr}},
              a.actorEmail||a.actorUserId||"—"),
            E("td",{style:{padding:"10px 12px",borderBottom:"1px solid "+P.bdr,fontWeight:600}}, a.action||"—"),
            E("td",{style:{padding:"10px 12px",borderBottom:"1px solid "+P.bdr,fontFamily:FC,fontSize:11}},
              a.targetId||a.licenseId||"—"),
            E("td",{style:{padding:"10px 12px",borderBottom:"1px solid "+P.bdr}}, a.product||"—"));
        })))
  );
}
